export default "__VITE_ASSET__882cf7d2__"